import { Factory } from 'rosie';
import './lib/uuid';

Factory.define('UnofferedCallNotification');

Factory.define('UnofferedCallNotificationWithDefaults')
  .extend('UnofferedCallNotification')
  .attr('id', 'call-id')
  .attr('reason', 'AGENT_TIMEOUT')
  .attr('type', 'UNOFFERED_CALL');



// WEBPACK FOOTER //
// ./factories/unoffered_call_notification_factory.js